import { render, staticRenderFns } from "./BaseSettings.vue?vue&type=template&id=7f63b41f&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./BaseSettings.vue?vue&type=script&lang=js&"
export * from "./BaseSettings.vue?vue&type=script&lang=js&"
import style0 from "./BaseSettings.vue?vue&type=style&index=0&id=7f63b41f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f63b41f",
  null
  
)

export default component.exports